import { Injectable } from '@angular/core';
import { SearchGQL, SearchQueryVariables } from '@epicuro-next/data/product';
import { Product, SearchQuery } from 'graphql-api/gql-api-interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const defaultFetchParams: Partial<SearchQuery> = {
  start: 0,
};

@Injectable()
export class PCardsService {
  constructor(private searchGQL: SearchGQL) {}

  public getProducts(query: SearchQuery): Observable<ReadonlyArray<Product>> {
    const fetchParams: SearchQueryVariables = {
      query: {
        ...defaultFetchParams,
        ...query,
      },
    };

    return this.searchGQL
      .fetch(fetchParams)
      .pipe(map((result) => result.data.search?.products as Product[]));
  }
}
